import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ConfigFile from '../../datasets/config_file';
import LargeButtonCard from '../shared-components/large_button_card';
import gameTemplateList from '../../datasets/game_template_list';

class PlayGameTemplateModal extends Component {
  constructor(props) {
    super(props);
    this.state={
         gameHelp: false
    };    
  
    this.startGameTemplateArr = [];
    if (this.props.gameTemplateArr){
        for (let i=0; i<gameTemplateList.length; i++){
            const buttonText = gameTemplateList[i].buttonText;
            if (this.props.gameTemplateArr.includes(buttonText)){
               this.startGameTemplateArr.push(gameTemplateList[i]);
            }
        }
    }else{
        const enableUnlockedFeaturesTemplate = ConfigFile.gameStartItems.enableUnlockedTemplate;
        this.startGameTemplateArr = gameTemplateList;
        if (enableUnlockedFeaturesTemplate !== true){
            const unlockIndx = 
                this.startGameTemplateArr.findIndex(elem => elem.buttonText === "unlockedFeaturesEnabled");
            if (unlockIndx !== -1){
                this.startGameTemplateArr.splice(unlockIndx,1);
            }
        }
    }
  }
  
  render() { 
      // setting animation={false} in modal to prevent the "findDOMNode is deprecated" warning msg
       this.startGameButtonList = this.startGameTemplateArr.map((templateList, index) =>
          <LargeButtonCard key={index} itemList={templateList} 
              buttonClicked={(templateName) => this.props.loadTemplate(templateName)}
          />        
      );
  return <>
        <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="xs"
            animation={false}>
          <Modal.Header className="gameModalHdrFtrBackground" closeButton>
            <Modal.Title>Would You Like To Try a Pre-set Game?</Modal.Title> 
          </Modal.Header>
          <Modal.Body >
                <div className="mr-2 ml-2">
                    <div>
                         If you would like to try playing a game that has already been setup,
                         choose one of the following (click on the button)....OR.... click the "Play My 
                         Own Game" button to setup your own game.
                    </div>
                </div>

                <div className="text-left ml-5 mt-1">
                   {this.startGameButtonList}
                </div>
          </Modal.Body>
          <Modal.Footer className="gameModalHdrFtrBackground text-right">
              <div className="mr-5">
                  <Button variant="primary"   onClick={() => this.props.onClose()}>
                        Play My Own Game
                  </Button>
              </div>
          
              <img src="./assets/sidebar_icon.png" className="train_icon_thumbnail_img mx-0 d-block"
                alt="trainIcon"/>
            </Modal.Footer>
          </Modal>  
    
    </>
  }

 
}
export default PlayGameTemplateModal;